import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  mobile: string = '';
  password: string = '';

  activeTab = 'login';
  toastMessage = '';
  showToastMessage = false;
  signupOtp = '';
  showPassword = false;
  showForgotNewPassword = false;
  showForgotConfirmPassword = false;
  passwordResetSuccess = false;
  otpSent = false;
  otpSentForgot = false;
  otpVerified = false;
  showForgotPassword = false;

  signupPasswordTouched = false;
  loginPasswordTouched = false;

  forgotNewPasswordTouched = false;
  confirmPasswordTouched = false;
  forgotOtpTouched = false;
  loginArray = [
    {
      staffId: "abc",
      name: "saikumar",
      mobile: "7036268769",
      email: "saikumar@gmail.com",
      builderId: "builder001",
      password: "7036268769@Sai"
    },
    {
      staffId: "bca",
      name: "sairam",
      mobile: "9951262369",
      email: "sairam@gmail.com",
      builderId: "builder002",
      password: "9951262369@Sai"

    },
    {
      staffId: "cab",
      name: "sweety",
      mobile: "9030523778",
      email: "sweety@gmail.com",
      builderId: "builder003",
      password: "9030523778"

    }
  ]
  countryCodes = [
    { code: '+91', flag: '🇮🇳' },
    { code: '+1', flag: '🇺🇸' },
    { code: '+44', flag: '🇬🇧' },
    { code: '+971', flag: '🇦🇪' },
    { code: '+61', flag: '🇦🇺' }
  ];

  selectedCountryCode = '+91';
  forgotCountryCode = '+91';

  signupForm: FormGroup;
  loginForm: FormGroup;

  passwordRulesSignup = { length: false, number: false, uppercase: false, special: false };
  passwordRulesLogin = { length: false, number: false, uppercase: false, special: false };
  forgotPasswordRules = { length: false, number: false, uppercase: false, special: false };

  forgotMobile = '';
  forgotOtp = '';
  forgotNewPassword = '';
  forgotConfirmPassword = '';

  forgotMobileError = false;
  passwordsDontMatch = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private rsbService: RsbService,
    private rsbLookup: RsbLookupModel,
  ) {

    this.signupForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      otp: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      role: ['', Validators.required]   // NEW FIELD
    });

    this.loginForm = this.fb.group({
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  get s() { return this.signupForm.controls }
  get l() { return this.loginForm.controls }

  onCountryChange(code: string) {
    this.selectedCountryCode = code;
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleForgotNewPassword() {
    this.showForgotNewPassword = !this.showForgotNewPassword;
  }

  toggleForgotConfirmPassword() {
    this.showForgotConfirmPassword = !this.showForgotConfirmPassword;
  }

  checkPassword(type: string, event: any) {

    const value = event.target.value || '';

    const rules = {
      length: value.length >= 6
    } as any;

    if (!value) {
      rules.length = false;
    }

    if (type === 'signup') this.passwordRulesSignup = rules;
    if (type === 'login') this.passwordRulesLogin = rules;
  }

  checkPasswordForgotNew(event: any) {

    const value = event.target.value || '';

    this.forgotPasswordRules = {
      length: value.length >= 6
    } as any;

    this.onConfirmPasswordChange();
  }

  onConfirmPasswordChange() {

    if (!this.forgotConfirmPassword) {
      this.passwordsDontMatch = false;
      return;
    }

    this.passwordsDontMatch =
      this.forgotNewPassword !== this.forgotConfirmPassword;
  }

  sendOtp() {

    if (this.s['mobile'].invalid) {
      this.s['mobile'].markAsTouched();
      return;
    }

    this.otpSent = true;
  }

  showForgotPasswordFlow() {

    this.showForgotPassword = true;
    this.otpSentForgot = false;

    this.resetForgotPasswordFields();
  }

  backToLogin() {

    this.showForgotPassword = false;
    this.resetForgotPasswordFields();
  }

  validateMobile(mobile: string) {
    return /^[0-9]{10}$/.test(mobile);
  }


  validateForgotMobile() {

    if (!this.forgotMobile) {
      this.forgotMobileError = false;
      return;
    }

    this.forgotMobileError = !/^[0-9]{10}$/.test(this.forgotMobile);

  }

  sendOtpForgot() {

    if (!/^[0-9]{10}$/.test(this.forgotMobile)) {
      this.forgotMobileError = true;
      return;
    }

    this.forgotMobileError = false;
    this.otpSentForgot = true;

  }
  isResetPasswordValid() {

    if (!this.forgotOtp || this.forgotOtp.length !== 6) return false;

    if (!this.forgotNewPassword) return false;

    if (!this.forgotPasswordRules.length) return false;

    if (this.passwordsDontMatch) return false;

    return true;
  }
  // resetPassword(){

  //   if(!this.isResetPasswordValid()) return;

  //   this.showToast("Password changed successfully");

  //   setTimeout(()=>{
  //     this.backToLogin();
  //   },1500);


  //    this.rsbService.resetpass(
  //     this.forgotMobile,
  //     this.forgotOtp,
  //     this.forgotNewPassword
  //   ).subscribe((res:any) => {
  //     console.log(res);
  //   });

  // }


  showToast(message: string) {

    this.toastMessage = message;
    this.showToastMessage = true;

    setTimeout(() => {
      this.showToastMessage = false;
    }, 3000);

  }

  verifyOtpSignup() {

    const otp = this.signupForm.get('otp')?.value || '';

    if (otp.length === 6) {
      this.otpVerified = true;
    } else {
      this.otpVerified = false;
    }

  }

  resetForgotPasswordFields() {

    this.forgotMobile = '';
    this.forgotOtp = '';
    this.forgotNewPassword = '';
    this.forgotConfirmPassword = '';

    this.passwordsDontMatch = false;

    this.forgotNewPasswordTouched = false;
    this.confirmPasswordTouched = false;
    this.forgotOtpTouched = false;

    this.forgotPasswordRules = { length: false } as any;
  }

  onForgotMobileChange() {

    const mobile = this.forgotMobile || '';

    if (mobile.length === 0) {
      this.forgotMobileError = false;
      return;
    }

    if (/^[0-9]{10}$/.test(mobile)) {
      this.forgotMobileError = false;
    } else {
      this.forgotMobileError = true;
    }

  }

  signup() {

    if (this.signupForm.invalid ||
      !this.passwordRulesSignup.length) {

      this.signupForm.markAllAsTouched();
      return;
    }

    if (!this.otpVerified) {
      return;
    }

    const countryCode = Number(this.selectedCountryCode.replace('+', ''));

    this.rsbService.builderCustomerRegistration(
      countryCode,
      this.signupForm.value.mobile,
      this.signupForm.value.password,
      this.signupForm.value.name,
      this.signupForm.value.email
    ).subscribe({
      next: () => {
        this.showToast('Signup successful');
        this.activeTab = 'login';
        this.signupForm.reset();
        this.otpVerified = false;
        this.otpSent = false;
      },
      error: () => {
        this.showToast('Signup failed');
      }
    });

  }

  loginstaff() {

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const countryCode = Number(this.selectedCountryCode.replace('+', ''));

    this.rsbService.builderCustomerLogin(
      countryCode,
      this.loginForm.value.mobile,
      this.loginForm.value.password
    ).subscribe({
      next: (res: any) => {
        // Ensure lookup model has the logged user and token
        if (res) {
          if (res.contents && res.contents.length) {
            this.rsbLookup.setLoggedUser(res.contents[0]);
            this.showToast('Login successful');
            this.router.navigate(['/home']);
          } else if (res.customer) {
            this.rsbLookup.setLoggedUser(res.customer);
          }
          if (res.customerToken) {
            this.rsbLookup.setToken(res.customerToken);
          }
        }

      },
      error: () => {
        this.showToast('Login failed');
      }
    });

  }

  // loginstaff() {

  //   console.log("Button Clicked");

  //   this.router.navigate(['/home']);

  // }

  // login(){
  //   this.rsbService.login(this.mobile,this.password).subscribe(res=>
  //     console.log(res)
  //   )
  // }
  // password(email: any, password: any) {
  //   throw new Error('Method not implemented.');
  // }
  // login(){

  //   if(this.loginForm.invalid){
  //     this.loginForm.markAllAsTouched();
  //     return;
  //   }

  //   const fullMobile =
  //     this.selectedCountryCode + this.l['mobile'].value;

  //   const password = this.l['password'].value;

  //   this.rsbService.practicelogin(fullMobile, password)
  //   .subscribe({

  //     next: (res:any) => {
  //       console.log("Login Response:", res);

  //       // Navigate when API responds
  //       this.router.navigate(['/home']);
  //     },

  //     error: (err) => {
  //       console.error("Login Error:", err);

  //       // Optional: show message
  //       this.showToast("Server not reachable");

  //     }

  //   });


}
// login(){
//   this.router.navigate(['/home']);
// }